import React from 'react';
import "./Dropdown.css";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";


const CreatePopUp = (props) => {
    const { open, handleClose, newpopup, setCreate } = props;
    
    const handleClosed = () => {
        setCreate(newpopup);
        handleClose();
    }
 
    return <div className="flexCol pdngSM">
        <Dialog
            open={open}
            fullWidth
            maxWidth="xs"
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* <DialogTitle id="alert-dialog-title" className='justifyCntr'>{"Use Google's location service?"}</DialogTitle> */}
            <DialogContent >
            <DialogContentText id="alert-dialog-description">

                    <div className="flexMinWidthCol">
                        <h3 className="flexRow alignCenter justifyCenter">{newpopup === 'DEPARMENT' ?  "No deparment found!" : newpopup === "specialization" ? "No specialization found!" : "No degree found!"} </h3>
                        <span className="lightTxt alignCenter justifyCenter">Create  by clicking below button</span>
                    </div>
                    <div className="flexRow alignCenter justifyCenter mrgTop8">
                        
                        <Button onClick={handleClosed} color="primary" variant="outlined">
                            {newpopup === "DEPARMENT" ? "Create Department" : newpopup === "specialization" ? "Create Specialization" : "Create Degree"}
                        </Button>
                    </div>
            </DialogContentText >
            </DialogContent>
        </Dialog>
    </div>
};

export default CreatePopUp;